import { Component } from '@angular/core';
import { UserService } from '../Services/user.service';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-user',
  imports: [HttpClientModule, CommonModule, FormsModule],
  templateUrl: './user.component.html',
  styleUrl: './user.component.css',
  providers: [UserService],
})
export class UserComponent {
  users: any;
  userSearchTerm: string = '';
  name: string = '';
  ipAddress: string = '';
  email: string = '';
  token: string = '';
  username: string = '';
  password: string = '';
  selectedRole: string = '';
  StoreId: number = 0;
  isToken: boolean = true;
  disabled = false;
  hoveredUser: string | null = null;
  loading = true;
  currentUsername: string | null = null;
  editUser: any = {};
  originalUser: any = {};
  selectedUserForReset: any = null;
  newPassword: string = '';
  showPassword: boolean = false;
  addFormSubmitted = false;

  //pagination
  pageNumber = 1;
  pageSize = 15;
  totalCount = 0;
  paginatedUsers: any[] = [];
  constructor(private _userservice: UserService) {}
  ngOnInit() {
    this.getAllUsers();
    this.currentUsername = this._userservice.getCurrentUsername();
    this.token = localStorage.getItem('token') || '';
    const storeId = this._userservice.getStoreId();
    this.StoreId = storeId ? Number(storeId) : 0;
    console.log('StoreId: ', this.StoreId);
  }
  getAllUsers() {
    this.loading = true;
    this._userservice.getUsers().subscribe((response: any) => {
      // this.users = response.result;
      const allUsers = response.result;
      if (this.currentUsername) {
        const currentUser = allUsers.find(
          (u: any) => u.userName === this.currentUsername,
        );
        const otherUsers = allUsers.filter(
          (u: any) => u.userName !== this.currentUsername,
        );
        this.users = currentUser ? [currentUser, ...otherUsers] : allUsers;
      } else {
        this.users = allUsers;
      }
      console.log(response);
      this.loading = false;
      this.updatePaginatedUsers();
    });
  }
  filteredUsers() {
    if (!this.users) return [];

    const term = this.userSearchTerm.toLowerCase();

    return this.users.filter((user: any) => {
      return (
        user.name?.toLowerCase().includes(term) ||
        user.email?.toLowerCase().includes(term)
      );
    });
  }
  addUser() {
    const userInfo: any = {
      name: this.name,
      email: this.email,
      ipAddress: this.ipAddress,
      roleToAssign: this.selectedRole,
    };
    if (
      (this.selectedRole === 'StoreAdmin' ||
        this.selectedRole === 'StoreUser') &&
      this.StoreId
    ) {
      userInfo.StoreId = this.StoreId;
    }
    console.log(userInfo);

    this._userservice.addNewUser(userInfo).subscribe({
      next: (res: any) => {
        this.getAllUsers();
        this.token = res.apiKey;
        this.username = res.user;
        this.password = res.password;
        this.isToken = true;
      },
      error: (err) => {
        console.error('Error adding user:', err);
        Swal.fire({
          text: `Error adding user: ${err}`,
          icon: 'warning',
          timer: 2000,
          confirmButtonText: 'OK',
        });
      },
    });
    this.disabled = true;
  }
  onAddUser(form: any) {
    this.addFormSubmitted = true;

    if (form.invalid) {
      return;
    }

    this.addUser();
  }
  resetAddUserForm(form: any) {
    if (!form) return;

    this.addFormSubmitted = false;
    form.resetForm();
  }

  openEditUser(user: any) {
    this.originalUser = { ...user };
    this.editUser = { ...user };

    const modalElement = document.getElementById('editUserModal');
    if (modalElement) {
      const modal = new (window as any).bootstrap.Modal(modalElement);
      modal.show();
    }
  }
  updateUser() {
    const payload: any = {
      userName: this.editUser.userName,
      name: this.editUser.name,
      email: this.editUser.email,
    };

    this._userservice.updateUser(this.editUser.userName, payload).subscribe({
      next: () => {
        Swal.fire('Updated!', 'User updated successfully', 'success');
        this.getAllUsers();

        const modalEl = document.getElementById('editUserModal');
        const modalInstance = (window as any).bootstrap.Modal.getInstance(
          modalEl,
        );
        modalInstance?.hide();
      },
      error: () => {
        Swal.fire('Error', 'Failed to update user', 'error');
      },
    });
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
  }

  openResetPassword(user: any) {
    this.selectedUserForReset = user;
    this.newPassword = '';

    const modalEl = document.getElementById('resetPasswordModal');
    const modal = new (window as any).bootstrap.Modal(modalEl);
    modal.show();
  }

  confirmResetPassword() {
    if (!this.newPassword || this.newPassword.length < 6) {
      Swal.fire('Password must be at least 6 characters');
      return;
    }

    this._userservice
      .resetPassword(this.selectedUserForReset.userName, this.newPassword)
      .subscribe({
        next: () => {
          Swal.fire('Success', 'Password reset successfully', 'success');

          const modalEl = document.getElementById('resetPasswordModal');
          const modalInstance = (window as any).bootstrap.Modal.getInstance(
            modalEl,
          );
          modalInstance?.hide();
        },
        error: () => {
          Swal.fire('Error', 'Failed to reset password', 'error');
        },
      });
  }

  deactivateUser(user: any) {
    Swal.fire({
      title: 'Deactivate user?',
      text: `This will disable login for ${user.name}`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, deactivate',
      cancelButtonText: 'Cancel',
    }).then((result) => {
      if (result.isConfirmed) {
        this._userservice.deactivateUser(user.userName).subscribe({
          next: (res: any) => {
            Swal.fire('Done', res.message, 'success');
            this.getAllUsers();
          },
          error: () => {
            Swal.fire('Error', 'Failed to deactivate user', 'error');
          },
        });
      }
    });
  }

  reactivateUser(user: any) {
    Swal.fire({
      title: 'Reactivate user?',
      text: `${user.name} will be able to login again`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Reactivate',
    }).then((result) => {
      if (result.isConfirmed) {
        this._userservice.reactivateUser(user.userName).subscribe({
          next: () => {
            Swal.fire('Success', 'User reactivated', 'success');
            this.getAllUsers();
          },
          error: () => {
            Swal.fire('Error', 'Failed to reactivate user', 'error');
          },
        });
      }
    });
  }

  // copyToken(token: string) {
  //   navigator.clipboard.writeText(token).then(
  //     () => {
  //       Swal.fire({
  //                 text: 'Token copied to clipboard',
  //                 icon: 'success',
  //                 timer: 1000,
  //                 confirmButtonText: 'OK',
  //               });
  //     },
  //     (err) => {
  //       console.error('Could not copy token: ', err);
  //     }
  //   );
  // }
  copyToken(): void {
    let combinedText = '';
    if (this.selectedRole === 'StoreUser') {
      combinedText = `Username: ${this.username}\nPassword: ${this.password}`;
    } else if (this.selectedRole === 'StoreAdmin') {
      combinedText = `Token: ${this.token}\nUsername: ${this.username}\nPassword: ${this.password}`;
    }
    navigator.clipboard.writeText(combinedText).then(
      () => {
        Swal.fire('Copied!', 'Details copied to clipboard', 'success');
      },
      (err) => {
        console.error('Clipboard copy failed:', err);
        Swal.fire('Error', 'Could not copy token', 'error');
      },
    );
  }
  onModalClose() {
    this.name = '';
    this.email = '';
    this.ipAddress = '';
    this.isToken = false;
    this.disabled = false;
    this.selectedRole = '';
    this.username = '';
    this.password = '';
    this.token = '';
  }

  //pagination
  onSearchChange() {
    this.pageNumber = 1;
    this.updatePaginatedUsers();
  }
  updatePaginatedUsers() {
    const startIndex = (this.pageNumber - 1) * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.paginatedUsers = this.filteredUsers().slice(startIndex, endIndex);
  }
  totalPages(): number {
    return Math.ceil(this.filteredUsers().length / this.pageSize);
  }
  visiblePages(): number[] {
    const total = this.totalPages();
    const current = this.pageNumber;
    let start = Math.max(current - 1, 1);
    let end = Math.min(start + 2, total);

    if (end - start < 2) {
      start = Math.max(end - 2, 1);
    }

    const pages: number[] = [];
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    return pages;
  }
  goToPage(page: number) {
    if (page !== this.pageNumber) {
      this.pageNumber = page;
      this.updatePaginatedUsers();
    }
  }
  nextPage() {
    if (this.pageNumber < this.totalPages()) {
      this.pageNumber++;
      this.updatePaginatedUsers();
    }
  }
  previousPage() {
    if (this.pageNumber > 1) {
      this.pageNumber--;
      this.updatePaginatedUsers();
    }
  }
}
